import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useChats } from 'shared/hooks/useChats';
import { useRenderContactButtons } from 'shared/hooks/useRenderContactButtons';
import { selectOfferId } from 'shared/selectors';
import { selectEarlyAccessContactsFlowEnabled } from 'shared/selectors/earlyAccess/selectEarlyAccessContactsFlowEnabled';

import { useEarlyAccessPaywallContext } from '../../../packages/EarlyAccessPaywall';
import { EStatus, ESubscriptionLimitType } from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { offerChatSelector } from '../../selectors/offerChat';

export const AuthorSendMessageContainer = () => {
  const offerChat = useSelector(offerChatSelector);
  const { showChatButton } = useRenderContactButtons();
  const { handleOpenChat } = useChats();
  const offerId = useSelector(selectOfferId);

  const { checkContactsAccess, status } = useEarlyAccessPaywallContext();
  const isEarlyAccessContactsFlowEnabled = useSelector(selectEarlyAccessContactsFlowEnabled);

  const renderChat = offerChat && offerChat.isChatsEnabled && showChatButton;

  const handleSendMessageClick = React.useCallback(async () => {
    if (isEarlyAccessContactsFlowEnabled) {
      const isConfirmed = await checkContactsAccess({ offerId, limitType: ESubscriptionLimitType.PhoneNumber });

      if (isConfirmed) {
        handleOpenChat();
      }

      return;
    }

    handleOpenChat();
  }, [checkContactsAccess, handleOpenChat, isEarlyAccessContactsFlowEnabled, offerId]);

  if (!renderChat) {
    return null;
  }

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleSendMessageClick} loading={status === EStatus.Loading}>
      Написать сообщение
    </Button>
  );
};
